import { StaticResourceApi } from 'api/StaticResourceApi';
import { backendApiClient } from 'container/backendApiClient';

export const staticResourceApi = new StaticResourceApi(backendApiClient);
